function headerReveal() { 
    if (window.scrollY < scrollPos) { 
        //scroll up
        gsap.to(header, {
            delay: 0.1,
            duration: 0.3,
            top: 0,
            ease: "power2.linear"
        });
    } else if (window.scrollY > window.innerHeight / 2) {
        //scroll down
        gsap.to(header, {
            delay: 0.1,
            duration: 0.3,
            top: -125,
            ease: "power2.linear"
        });
    }

    //single page
    if (typeof singleHeader != "undefined" && singleHeader != null) {
        if (window.scrollY <= 0) {
            gsap.to(singleHeader, {
                duration: 0.3,
                backgroundColor: "rgba(135, 93, 186, 0)"
            });
        } else {
            gsap.to(singleHeader, {
                duration: 0.3,
                backgroundColor: "rgba(135, 93, 186, 1)"
            });
        }
    }

    scrollPos = window.scrollY;
}
